<!--<div class="card mb-0">-->
Parent
<div *ngIf="!parent" class="text-900 font-medium text-xl">NOT FOUND</div>
<div *ngIf="parent" class="flex">
  <div class="pr-3" style="width: 200px">
    <img [alt]="parent.firstName" [src]="parent.imageURL.length < 5 ? imageURL : parent.imageURL"
         class="shadow-4" width="100%"/>
  </div>
  <div class="flex">
    <div style="width: 100px">
      <p style="font-weight: bolder">ID</p>
      <p>First Name</p>
      <p>Last Name</p>
      <p>Phone</p>
      <p>Email</p>
    </div>
    <div>
      <p><a [routerLink]="['/' ,'dashboard', 'parent', 'detail', parent.id]"> #{{ parent.id }} </a></p>
      <p> {{ parent.firstName }} </p>
      <p> {{ parent.lastName }} </p>
      <p><a [href]="'tel:' + parent.phoneNumber">{{ parent.phoneNumber }}</a></p>
      <p><a [href]="'mailto:' + parent.email">{{ parent.email }}</a></p>
    </div>
  </div>
</div>
<!--</div>-->
